import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { slashToSnakeUrl } from '../../../utils/slash-to-snake-url'
import { shortCurrency } from '../../../utils/currency'

import styles from './product-card.module.scss'
import { Link } from 'react-router-dom'

function ProductCard(props) {
  const {
    content: {
      view,
      viewTitle,
      path,
      product,
      title,
      price,
      price: { basePrice, currentPrice },
    },
    className,
    size,
    ga,
    currency,
    isProductsApp,
  } = props
  const hasDiscount = currentPrice < basePrice

  const productCartLinkHandler = () => {
    if (!ga) return

    window.ga('send', 'event', ga.category, 'click', slashToSnakeUrl(path))
  }

  return (
    <div className={classNames(styles.root, styles[`${size}Root`], className)}>
      {view && !isProductsApp ? (
        <Link
          to={path}
          className={styles.viewWrap}
          onClick={productCartLinkHandler}
        >
          <img
            loading="lazy"
            src={view}
            title={viewTitle}
            alt={product || title || `Изображение продукта`}
            className={styles.view}
          />
        </Link>
      ) : (
        view && (
          <a
            href={path}
            className={styles.viewWrap}
            onClick={productCartLinkHandler}
          >
            <img
              loading="lazy"
              src={view}
              title={viewTitle}
              alt={product || title || `Изображение продукта`}
              className={styles.view}
            />
          </a>
        )
      )}
      <div className={styles.footer}>
        {product && !isProductsApp ? (
          <Link
            to={path}
            className={styles.product}
            onClick={productCartLinkHandler}
          >
            {product}
          </Link>
        ) : (
          product && (
            <a
              href={path}
              className={styles.product}
              onClick={productCartLinkHandler}
            >
              {product}
            </a>
          )
        )}
        {title && !isProductsApp ? (
          <Link
            to={path}
            className={styles.title}
            onClick={productCartLinkHandler}
          >
            {title}
          </Link>
        ) : (
          title && (
            <a
              href={path}
              className={styles.title}
              onClick={productCartLinkHandler}
            >
              {title}
            </a>
          )
        )}
        {price && (
          <div className={styles.price}>
            {hasDiscount && <div className={styles.basePrice}>{basePrice}</div>}
            <div className={styles.currentPrice}>
              {currentPrice}
              {shortCurrency(currency, currentPrice)}
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

ProductCard.defaultProps = {
  size: `small`,
}

ProductCard.propTypes = {
  content: PropTypes.shape({
    product: PropTypes.string,
    title: PropTypes.string,
    price: PropTypes.object,
    view: PropTypes.string.isRequired,
    path: PropTypes.string.isRequired,
  }).isRequired,
  className: PropTypes.string,
  size: PropTypes.oneOf([`small`, `tile`, `teaser`]),
}

const mapStateToProps = (state) => ({
  currency: state.currency,
})

export default connect(mapStateToProps)(ProductCard)
